import React from 'react';
import { RingLoader } from 'react-spinners';
import './CreativeEditorModal.css';

export default function CreativeProcessingOverlay({ message }) {
    return (
        <>
            <div className="creativeProcessingBackdrop" aria-hidden="true" />
            <div
                className="creativeProcessingPanel"
                role="alertdialog"
                aria-modal="true"
                aria-busy="true"
                aria-labelledby="creative-processing-title"
            >
                <RingLoader
                    color="#C52F00"
                    loading
                    size={48}
                    aria-label="Loading"
                />
                <p id="creative-processing-title" className="creativeProcessingMessage">
                    {message}
                </p>
                <p className="creativeProcessingSubtext">Please wait…</p>
            </div>
        </>
    );
}
